const rows = [
  { feature: 'Updated Daily', ours: true, random: false },
  { feature: 'QC Information', ours: true, random: false },
  { feature: 'Seller Ratings', ours: true, random: false },
  { feature: 'Price Comparison', ours: true, random: false },
  { feature: 'Buying Guides', ours: true, random: false },
  { feature: 'Shipping Tips', ours: true, random: false },
  { feature: 'Verified Listings', ours: true, random: false },
];

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 text-center mb-10">
          Compare Before You Buy
        </h2>

        <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60">
          <div className="grid grid-cols-3 bg-foreground-900 text-background-50">
            <div className="px-6 py-4 text-sm font-semibold">Feature</div>
            <div className="px-6 py-4 text-sm font-semibold text-center">Our Spreadsheet</div>
            <div className="px-6 py-4 text-sm font-semibold text-center">Random Seller Lists</div>
          </div>

          {rows.map((row, i) => (
            <div
              key={row.feature}
              className={`grid grid-cols-3 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}
            >
              <div className="px-6 py-5 text-sm text-foreground-700 font-medium">{row.feature}</div>
              <div className="px-6 py-5 text-center">
                {row.ours ? (
                  <i className="ri-checkbox-circle-fill text-primary-500 text-lg"></i>
                ) : (
                  <span className="text-foreground-300">—</span>
                )}
              </div>
              <div className="px-6 py-5 text-center">
                {row.random ? (
                  <i className="ri-checkbox-circle-fill text-primary-500 text-lg"></i>
                ) : (
                  <span className="text-foreground-300">—</span>
                )}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-foreground-500 mt-6">
          Our <strong>AllChinaBuy spreadsheet</strong> gives you everything you need — all in one organized place.
        </p>
      </div>
    </section>
  );
}